<template>
  <div>
    <Modal v-model="visible" :title="title" :hasFooter="false" @on_cancel="closeModal">
      <template slot="body">
        <div v-if="current == 2">
          <EnrollTpl
            :clean="visible"
            @go_login="goLogin"
            @login_success="loginSuccessHandler"
            @on_cancel="closeModal"
          ></EnrollTpl>
        </div>
        <div v-if="current == 1">
          <LoginTpl
            :clean="visible"
            @go_enroll="goEnroll"
            @login_success="loginSuccessHandler"
            @on_cancel="closeModal"
          ></LoginTpl>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Modal from './Modal.vue'
import EnrollTpl from './EnrollTpl.vue'
import LoginTpl from './LoginTpl.vue'
export default {
  name: 'CmineLogin',
  data() {
    return {
      visible: this.value,
      show: false,
      title: '密码登录'
    }
  },
  props: {
    current: {
      type: Number,
      default: 1
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function(val) {
      if (val) {
        if (this.current == 1) {
          this.title = '密码登录'
        } else {
          this.title = '注册账号'
        }
      }
      this.visible = val
    },
    current: {
      handler: function(val) {
        if (val == 2) {
          this.title = '注册账号'
        } else {
          this.title = '密码登录'
        }
      },
      deep: true
    }
  },
  model: {
    prop: 'value',
    event: 'on_cancel'
  },
  mounted() {},
  methods: {
    loginSuccessHandler(flag) {
      this.$emit('login_success', flag)
    },
    goLogin() {
      this.$emit('go_login')
    },
    goEnroll() {
      this.$emit('go_enroll')
    },
    closeModal: function() {
      this.visible = false
      this.$emit('on_cancel')
      this.$store.commit('SET_USER_VERIFY', false)
    }
  },
  components: { Modal, EnrollTpl, LoginTpl }
}
</script>
<style scoped lang="scss">
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 1.4s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  background: blue;
}
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */ {
  opacity: 0;
  width: 200px;
  background: red;
}
</style>
